/**
 * Phase 32 — Pending-approvals nav badge for the manager top bar.
 *
 * Polls `/payment-approvals/pending-count` every 30s and on focus,
 * mirroring the existing AlertsBadge pattern. Click navigates to
 * `/approvals`. The count badge shows in amber to differentiate from
 * the destructive (rose) AlertsBadge.
 */
import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { HandCoins } from "lucide-react";
import { api } from "@/lib/api";

export default function ApprovalsBadge() {
  const [count, setCount] = useState(0);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/payment-approvals/pending-count");
      setCount(Number(data?.count || 0));
    } catch { /* silent */ }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(t); window.removeEventListener("focus", onFocus); };
  }, [load]);

  return (
    <Link
      to="/approvals"
      className="relative inline-flex items-center justify-center h-9 w-9 rounded-md hover:bg-secondary"
      data-testid="approvals-bell"
      title="Pending payment approvals"
    >
      <HandCoins className="h-4 w-4" />
      {count > 0 && (
        <span
          className="absolute -top-1 -right-1 h-4 min-w-[16px] px-1 rounded-full bg-amber-500 text-white text-[10px] font-bold grid place-items-center"
          data-testid="approvals-badge-count"
        >
          {count > 99 ? "99+" : count}
        </span>
      )}
    </Link>
  );
}
